import {
  type SerializedAutoLinkNode,
  type SerializedLinkNode,
} from '@payloadcms/richtext-lexical';
import { type JSXConverters } from '@payloadcms/richtext-lexical/react';

export const ParagraphConverter: JSXConverters<
  SerializedAutoLinkNode | SerializedLinkNode
> = {
  paragraph: ({ node, nodesToJSX }) => {
    const children = nodesToJSX({
      nodes: node.children,
    });

    // Check if the paragraph ends with linebreak(s) - add nbsp to make them visible
    const lastChild = node.children?.[node.children.length - 1];
    const endsWithLinebreak = lastChild?.type === 'linebreak';

    return (
      <p className="!font-normal">
        {children}
        {endsWithLinebreak && '\u00A0'}
      </p>
    );
  },
};
